export interface BaseSlideShowItem {
  id: string;
  className?: string;
  index: number;
  duration?: SlideshowDuration;
  type: SlideShowItemType;
  isSelected?: boolean;
}

export enum SlideShowItemType {
  TEXT = 'text',
  IMAGE = 'image',
  VIDEO = 'video',
}

export interface SlideshowDuration {
  showDuration: boolean;
  duration: number;
  onChangeDuration(val: number, id?: string): void;
  onChangeDurationEnded(val: number, id?: string): void;
}

export type SlideShowListItemType = TextSlideListItem | ImageSlideListItem | VideoSlideListItem;

export interface TextSlideListItem extends BaseSlideShowItem, TextSlideHandlers, BaseSlideShowHandlers {
  type: SlideShowItemType.TEXT;
  input: string;
}
export interface ImageSlideListItem extends BaseSlideShowItem, BaseSlideShowHandlers {
  type: SlideShowItemType.IMAGE;
  getImgSrc(): Promise<string>;
}
export interface VideoSlideListItem extends BaseSlideShowItem, BaseSlideShowHandlers {
  type: SlideShowItemType.VIDEO;
  videoSrc: string;
}

export interface BaseSlideShowHandlers {
  onDelete(id: string): void;
  onClick(id: string, index?: number): void;
}

interface TextSlideHandlers {
  onInputChange(input: string, id?: string): void;
  onInputChangeEnded(val: string, id?: string): void;
}
